// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FuwEditImage_wrapper__9hNJa","cropper":"FuwEditImage_cropper__1lxtn","footer":"FuwEditImage_footer__3OWaG"};